/** Read-only SMTP configuration and notification queue visibility for operators. */

import React, { useCallback, useEffect, useState } from 'react';

import { getNotificationStatus } from './adminOpsApi';

const QUEUE_STATES = [
  ['Queued', 'queued'],
  ['In flight', 'in_flight'],
  ['Failed', 'failed'],
  ['Dead lettered', 'dead_lettered'],
];

export default function NotificationOutboxPanel() {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setBusy(true);
    setError(null);
    try {
      setStatus(await getNotificationStatus());
    } catch (failure) {
      setError(failure instanceof Error ? failure.message : 'notification status is unavailable');
    } finally {
      setBusy(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const queue = status && status.notification_queue;
  const byKind = queue && queue.by_kind ? queue.by_kind : {};

  return (
    <section className="admin-ops-notification-outbox" aria-labelledby="admin-ops-outbox-title">
      <header>
        <h2 id="admin-ops-outbox-title">Notification outbox</h2>
        <button type="button" className="secondary" onClick={refresh} disabled={busy}>
          {busy && !status ? 'Loading…' : 'Refresh'}
        </button>
      </header>

      {error ? (
        <p className="admin-ops-error" role="alert">Notification status unavailable: {error}</p>
      ) : null}
      {!status && busy ? <p role="status">Loading notification status…</p> : null}

      {status ? (
        <>
          {status.email_configured ? (
            <p>Email configured.</p>
          ) : (
            <p>email not configured</p>
          )}

          {queue && queue.available ? (
            Object.keys(byKind).length === 0 ? (
              <p>No notification kinds reported.</p>
            ) : (
              <table className="admin-ops-notification-counts">
                <caption>Notification queue counts by kind and status</caption>
                <thead>
                  <tr>
                    <th scope="col">Notification kind</th>
                    {QUEUE_STATES.map(([label]) => <th scope="col" key={label}>{label}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(byKind).map(([kind, counts]) => (
                    <tr key={kind}>
                      <th scope="row">{kind}</th>
                      {QUEUE_STATES.map(([, key]) => (
                        <td key={key}>{counts[key] ?? 0}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            )
          ) : (
            <p className="admin-ops-job-budget">Notification queue unavailable.</p>
          )}
        </>
      ) : null}
    </section>
  );
}
